import { ButtonProps } from '@chakra-ui/react';
import React from 'react';
import { LinkProps } from 'react-router-dom';
import { Button as ButtonChakra } from '@/components/Button/Button';

export default function Index(props: ButtonProps & LinkProps) {
  return <ButtonChakra {...props} />;
}
